import { type FilesViewerProps } from '../FilesViewer';

/** This component can show vectorial images (SVGs) */
export default function SvgViewer({ fileEncoded }: FilesViewerProps) {
	return <img className="w-full" src={`data:image/svg+xml;base64,${fileEncoded}`} alt="svg" />;
}
